export const PREPRINT_PENDING_MODERATION_DETAIL =
  'This preprint is pending moderation and is not yet publicly available.';
